import React from 'react';


import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkProductDischargeUserEntitlements,
    getProductDischargeUserEntitlementsProgress,
} from 'src/openapi/admin/apis/BulkProductDischargeUserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {FlatButton} from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UnassignProductUserEntitlementsModal} from './unassign-product-user-entitlements.modal';
import {
    selectUnassignProductUserEntitlementsBulkUuid,
    selectUnassignProductUserEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './unassign-product-user-entitlements.slice';

import type {UpdateUserEntitlementsRelation} from 'src/openapi/admin/models/UpdateUserEntitlementsRelation';

type Props = {
    userId: number,
    selectionKey: string,
    onDone: () => void,
};

export const UnassignProductUserEntitlementsTool = ({selectionKey, onDone, userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>{TOOL_TITLE}</b>
            </FlatButton>
            <BulkActionTool<UpdateUserEntitlementsRelation>
                shown={shown}
                onClose={onClose}
                width={MODAL_WIDTH}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectUnassignProductUserEntitlementsTask}
                uuidSelector={selectUnassignProductUserEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateUserEntitlementsRelation, options) => (
                    apiDispatch(bulkProductDischargeUserEntitlements({...options, updateUserEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getProductDischargeUserEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <UnassignProductUserEntitlementsModal
                        userId={userId}
                        selectionKey={selectionKey}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
